import React from 'react';

import { Box, Button, Grid, Typography, useTheme } from '@mui/material';
import { motion } from 'framer-motion';

import StyledOurPartners from './styles';

import parse from 'html-react-parser';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import amigogaming from '../../../assets/images/logos/provider/amigo-gaming.png';
import asiagaming from '../../../assets/images/logos/provider/asia-gaming.png';
import betgames from '../../../assets/images/logos/provider/betgames.png';
import betterlive from '../../../assets/images/logos/provider/better-live.png';
import bolebit from '../../../assets/images/logos/provider/bolebit.png';
import evolution from '../../../assets/images/logos/provider/evolution-gaming.png';
import fachai from '../../../assets/images/logos/provider/fa-chai.png';
import goatsports from '../../../assets/images/logos/provider/goat-sports.png';
import habanero from '../../../assets/images/logos/provider/habanero.png';
import hogaming from '../../../assets/images/logos/provider/ho-gaming.png';
import imaginelive from '../../../assets/images/logos/provider/imagine-live.png';
import jadesports from '../../../assets/images/logos/provider/jade-sports.png';
import jili from '../../../assets/images/logos/provider/jili.png';
import joker from '../../../assets/images/logos/provider/joker.png';
import kagaming from '../../../assets/images/logos/provider/ka-gaming.png';
import mglive from '../../../assets/images/logos/provider/mg-live.png';
import mg from '../../../assets/images/logos/provider/mg.png';
import pragmaticplaycasino from '../../../assets/images/logos/provider/pragmatic-play-casino.png';
import pragmaticplay from '../../../assets/images/logos/provider/pragmatic-play.png';
import prettygaming from '../../../assets/images/logos/provider/pretty-gaming.png';
import redtiger from '../../../assets/images/logos/provider/red-tiger.png';
import simpleplay from '../../../assets/images/logos/provider/simple-play.png';
import sportsplus from '../../../assets/images/logos/provider/sports-plus.png';
import tfgaming from '../../../assets/images/logos/provider/tf-gaming.png';



const OurPartners = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const label = `TC Gaming iGaming White Label Platform has more than 100+<br/> partners in the world, offering more than 8000+ games. Join us to<br/> succeed together!`;

  const partners = [
    {
      id: 1,
      image: evolution,
      width: '169px',
      height: '61px',
    },
    {
      id: 2,
      image: pragmaticplaycasino,
      width: '169px',
      height: '61px',
    },
    {
      id: 3,
      image: mg,
      width: '169px',
      height: '61px',
    },
    {
      id: 4,
      image: mglive,
      width: '169px',
      height: '61px',
    },
    {
      id: 5,
      image: imaginelive,
      width: '169px',
      height: '61px',
    },
    {
      id: 6,
      image: asiagaming,
      width: '169px',
      height: '61px',
    },
    {
      id: 7,
      image: hogaming,
      width: '169px',
      height: '61px',
    },
    {
      id: 8,
      image: betterlive,
      width: '169px',
      height: '61px',
    },
    {
      id: 9,
      image: betgames,
      width: '169px',
      height: '61px',
    },
    {
      id: 10,
      image: prettygaming,
      width: '169px',
      height: '61px',
    },
    {
      id: 11,
      image: bolebit,
      width: '169px',
      height: '61px',
    },
    {
      id: 12,
      image: redtiger,
      width: '169px',
      height: '61px',
    },
    {
      id: 13,
      image: amigogaming,
      width: '169px',
      height: '61px',
    },
    {
      id: 14,
      image: joker,
      width: '169px',
      height: '61px',
    },
    {
      id: 15,
      image: jili,
      width: '169px',
      height: '61px',
    },
    {
      id: 16,
      image: simpleplay,
      width: '169px',
      height: '61px',
    },
    {
      id: 17,
      image: fachai,
      width: '169px',
      height: '61px',
    },
    {
      id: 18,
      image: habanero,
      width: '169px',
      height: '61px',
    },
    {
      id: 19,
      image: kagaming,
      width: '169px',
      height: '61px',
    },
    {
      id: 20,
      image: pragmaticplay,
      width: '169px',
      height: '61px',
    },
    {
      id: 21,
      image: jadesports,
      width: '169px',
      height: '61px',
    },
    {
      id: 22,
      image: tfgaming,
      width: '169px',
      height: '61px',
    },
    {
      id: 23,
      image: sportsplus,
      width: '169px',
      height: '61px',
    },
    {
      id: 24,
      image: goatsports,
      width: '169px',
      height: '61px',
    },
  ];

  return (
    <StyledOurPartners>
      <Box className="homeBg">
        <Box
          sx={{
            textAlign: { xs: 'center', md: 'center' },
            zIndex: 1,
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 1,
            padding: '6.5% 10%',
            mt: 3,
            [theme.breakpoints.down('lg')]: {
              // padding: '13% 10%',
              mt: 2,
            }
          }}
        >
          <Typography
            variant="h2"
            component="h2"
            sx={{
              fontSize: '64px',
              fontWeight: '800',
              lineHeight: '56px',
              [theme.breakpoints.down('lg')]: {
                fontSize: '40px',
                fontWeight: 800,
                lineHeight: '47.73px',
                textAlign: 'center',
              },
            }}
          >
            <motion.div
              initial={{
                opacity: 0,
                y: 100,
              }}
              whileInView={{
                opacity: 1,
                y: 0, // Slide in to its original position
                transition: {
                  duration: 1, // Animation duration
                },
              }}
            // viewport={{ once: true }}
            >
              {t('about-title')}
            </motion.div>
          </Typography>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              mt: 3,
            }}
          >
            <Typography
              variant="body1"
              sx={{
                lineHeight: '26px',
                wordWrap: 'break-word',
                fontWeight: localStorage.getItem('i18nextLng') === 'en-US' ? '500' : '700',
                fontSize: '20px',
                mt: 1.5,
                [theme.breakpoints.down('lg')]: {
                  fontSize: '18px',
                  fontWeight: 500,
                  lineHeight: '23.4px',
                  textAlign: 'center',
                },
              }}
            >
              <motion.div
                initial={{
                  opacity: 0,
                  y: 100,
                }}
                whileInView={{
                  opacity: 1,
                  y: 0, // Slide in to its original position
                  transition: {
                    duration: 1, // Animation duration
                    delay: 0.8,
                  },
                }}
              // viewport={{ once: true }}
              >
                {parse(t('about-content'))}
              </motion.div>
            </Typography>
          </Box>
          <Box justifyContent={'center'} display={'flex'}>
            <Button
              variant="contained"
              onClick={() => navigate('/contact')}
              sx={{
                color: '#000000',
                backgroundColor: '#5B3EDE',
                borderColor: '#00AA2F',
                borderRadius: '4px',
                width: '185px',
                height: '50px',
                // marginRight: '30px',
                marginTop: 9,
                fontSize: '16px',
                fontWeight: 400,
                color: '#ffffff',
                [theme.breakpoints.down('lg')]: {
                  marginTop: 5,
                  fontSize: '18px',
                  lineHeight: '21.48px',
                  // marginRight: 'unset'
                },
              }}
            >
              {t('about-button')}
            </Button>
          </Box>
        </Box>
      </Box>
      <Box sx={{ textAlign: { xs: 'center', md: 'center' }, zIndex: 1 }} className="content">
        <Box
          mt={5}
          //   mb={10}
          px={25}
          display={'flex'}
          justifyContent={'center'}
          sx={{
            maxWidth: '100%',
            maxHeight: '100%',
            color: '#000000',
            [theme.breakpoints.down('lg')]: {
              px: 0,
            },
          }}
        >
          <Grid container justifyContent="center" mb={10} style={{ padding: '0px 20px' }}>
            {partners.map((item, index) => (
              <Grid item xs={6} sm={6} md={6} lg={3} xl={3} key={index} display="flex" justifyContent="center">
                <Box sx={{ maxWidth: '100%', maxHeight: '100%', mt: 5 }} display={'flex'} key={item.id}>
                  <Box
                    sx={{
                      backgroundColor: '#ffffff',
                      textAlign: 'center',
                      maxHeight: '100%',
                      [theme.breakpoints.down('lg')]: {
                        paddingLeft: '8px',
                        paddingRight: '8px',
                        // width: '200px !important',
                        // height: `${item.height} !important`,
                      },
                    }}
                  >
                    <Box
                      px={6}
                      sx={{
                        [theme.breakpoints.down('lg')]: {
                          // width: `${item.width} !important`,
                          // height: `${item.height} !important`,
                          display: 'flex',
                          justifyContent: 'center',
                          textAlign: 'center',
                          justifySelf: 'center',
                          px: 0,
                        },
                      }}
                    >
                      <img
                        src={item.image}
                        style={{
                          width: '100%',
                          height: 'auto',
                          // objectFit: 'cover',
                        }}
                      />
                    </Box>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
    </StyledOurPartners>
  );
};

export default OurPartners;
